import { Component, ViewChild } from '@angular/core';

import {App, Events, MenuController, Nav, NavController, Platform, ToastController} from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Storage } from '@ionic/storage';
import { Geolocation } from '@ionic-native/geolocation';

import { AboutPage } from '../pages/about/about';
import { TestPage } from '../pages/test/test';
import { AccountPage } from '../pages/account/account';
import { IdentityPage } from '../pages/account/identity/identity';
import { AddressPage } from '../pages/account/address/address';
import { CivilityPage } from '../pages/account/civility/civility';
import { CvPage } from '../pages/account/cv/cv';
import { CvAddForm } from '../pages/account/cv/form/cvform';
import { JobSelectForm } from '../pages/utils/job-select/job-select';
import { LoginPage } from '../pages/login/login';
import { AccountCompletePage} from "../pages/account/complete/complete";

import { NotificationsPage } from '../pages/account/notifications/notifications';

import { MissionsListPage } from '../pages/missions/missions-list/missions-list';
import { MissionsMapPage } from '../pages/missions/missions-map/missions-map';
import { MissionDetailPage } from '../pages/missions/mission-detail/mission-detail';

import { MissionsCandidatePage } from '../pages/missions/missions-candidate/mission-candidate-list/missions-candidate';
import { MissionsCandidateDetailPage } from '../pages/missions/missions-candidate/missions-candidate-detail/missions-candidate-detail';

import { MissionsContractListPage } from '../pages/missions/missions-contract/missions-contract-list/missions-contract-list';

import { MapPage } from '../pages/map/map';
import { SignupPage } from '../pages/signup/signup';
import { TabsPage } from '../pages/tabs-page/tabs-page';
import { TutorialPage } from '../pages/tutorial/tutorial';
import { SchedulePage } from '../pages/schedule/schedule';
import { SpeakerListPage } from '../pages/speaker-list/speaker-list';
import { SupportPage } from '../pages/support/support';

import { ConferenceData } from '../providers/conference-data';
import { UserData } from '../providers/user-data';
import { UiData } from '../providers/ui-data';
import { JobDataService } from '../providers/job-data';
import { PortalDataService } from '../providers/portal-data';
import {StatusBar} from '@ionic-native/status-bar';

import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { Badge } from '@ionic-native/badge';
import { FCM } from '@ionic-native/fcm';

import { ENV } from "@app/environment"
import {enableProdMode} from '@angular/core';
import {SelfRankingPage} from "../pages/account/self-ranking/self-ranking";
import {MissionsCalendarPage} from "../pages/missions/missions-candidate/missions-calendar/missions-calendar";
import {MissionsTabsPage} from "../pages/missions/missions-candidate/tabs/tabs";
import {SwitchPage} from "../pages/switch/switch";
import {HomePage} from "../pages/home/home";
import {MessagingPage} from "../pages/account/messaging/messaging";
import {LogService} from "../services/logger";
import {CvTabsPage} from "../pages/account/cv/tabs/tabs";

export interface PageInterface {
    title: string;
    name: string;
    component: any;
    icon: string;
    hidden?: boolean;
    notifications?: boolean;
    notifications_color?: boolean;
    logsOut?: boolean;
    index?: number;
    tabName?: string;
    tabComponent?: any;
    push?: any;
    root?: any;
    params?: any;
}

@Component({
    templateUrl: 'app.template.html'
})
export class ConferenceApp {
    // the root nav is a child of the root app component
    // @ViewChild(Nav) gets a reference to the app's root nav
    @ViewChild(Nav) nav: Nav;

    // List of pages that can be navigated to from the left menu
    // the left menu only works after login
    // the login page disables the left menu

    appPages: PageInterface[] = [
        { title: 'Tableau de bord', name: 'MissionsTabsPage', component: MissionsTabsPage, index:0, icon: 'home',  notifications: true },
       // { title: 'Tableau de bord', name: 'HomePage', component: HomePage, icon: 'home'},
       // { title: 'Déjà en poste ?', name: 'SwitchPage', component: SwitchPage, icon: 'download', push:true, params:{skippable:false} },
        { title: 'Trouver une mission', name: 'MissionsListPage', component: MissionsListPage, icon: 'search'},
       // { title: 'Autour de moi', name: 'MissionsMapPage', component: MissionsMapPage, icon: 'map', hidden: false },
       // { title: 'Mes missions', name: 'MissionsCandidatePage', component: MissionsCandidatePage, icon: 'calendar', hidden: true },
       // { title: 'Mes contrats', name: 'MissionsListPage', component: MissionsListPage, icon: 'calendar', hidden: true },
       // { title: 'Notifications', name: 'NotificationsPage', component: NotificationsPage, icon: 'notifications', notifications: true, hidden: true },
    ];
    userPages: any = {
        'cvPage':{ title: 'Mon CV', name: 'CvPage', component: CvPage, index: 0, icon: 'contact',push: false,root: true},
        'candidatesPage':{ title: 'Mon compte', name: 'HomePage', component: HomePage, icon: 'archive'},

        //'candidatesPage':{ title: 'Suivi d\'activité', name: 'MissionsTabsPage', component: MissionsTabsPage, index:0, icon: 'calendar', hidden: true, notifications: true },
        'contractsPage':{ title: 'Suivi', name: 'MissionsContractListPage', component: MissionsContractListPage, icon: 'calendar', hidden: false },
        'notificationsPage':{ title: 'Notifications', name: 'NotificationsPage', component: NotificationsPage, icon: 'notifications', notifications: true, hidden: false },
    };
    helpPages: PageInterface[] = [
        { title: 'Sample', name: 'TabsPage', component: TabsPage, tabComponent: SpeakerListPage, index: 1, icon: 'contacts' },
        { title: 'Home', name: 'HomePage', component: HomePage, icon: 'home' },
        { title: 'Messagerie', name: 'MessagingPage', component: MessagingPage, icon: 'bubble' },

        { title: 'Mon planning', name: 'TabsPage', component: TabsPage, tabComponent: SchedulePage, index: 0, icon: 'calendar' },
        { title: 'Autour de moi', name: 'TabsPage', component: TabsPage, tabComponent: MapPage, index: 2, icon: 'map' },
        { title: 'A propos', name: 'TabsPage', component: TabsPage, tabComponent: AboutPage, index: 3, icon: 'information-circle' },
        { title: 'Test', name: 'TabsPage', component: TabsPage, tabComponent: TestPage, index: 4, icon: 'contacts' },
        { title: 'Calendar', name: 'MissionsCalendarPage', component: MissionsCalendarPage, icon: 'log-in' },
    ];
    loggedInPages: PageInterface[] = [
        // { title: 'Profil', name: 'AccountPage', component: AccountPage, icon: 'contact' },
        //{ title: 'Aide', name: 'SupportPage', component: SupportPage, icon: 'help' },
        //{ title: 'Déconnexion', name: 'TabsPage', component: TabsPage, icon: 'log-out', logsOut: true }
    ];
    loggedOutPages: PageInterface[] = [
        { title: 'Login', name: 'LoginPage', component: LoginPage, icon: 'log-in' },
        { title: 'Support', name: 'SupportPage', component: SupportPage, icon: 'help' },
        { title: 'Signup', name: 'SignupPage', component: SignupPage, icon: 'person-add' }
    ];
    rootPage: any;
    notifications: any = false;
    candidates: any = false;
    contracts: any = false;
    fcmSubscription: any = false;
    env: any = 'prod';
    subscribeRef: any =false;
    sessionRef: any =false;
    listeners: any =false;
    available: any =false;


    constructor(
        public events: Events,
        public userData: UserData,
        public uiData: UiData,
        public menu: MenuController,
        public platform: Platform,
        public confData: ConferenceData,
        public storage: Storage,
        public splashScreen: SplashScreen,
        private screenOrientation: ScreenOrientation,
        public statusBar: StatusBar,
        public badge: Badge,
        private fcm: FCM,
        private toastCtrl: ToastController,
        private logger: LogService,
        protected app: App,
        public menuCtrl: MenuController
        //public nav: NavController,
        //public navCtrl: NavController

    ) {
        //this.rootPage = MissionsListPage;
        //console.log(ENV);
        this.env = ENV.ENV;
        var that = this;
        that.enableMenu(false);
        that.listenToLoginEvents();
        that.evaluateLogin();

    }
    ionAppDidLoad() {
    }
    evaluateLogin(login = false){
        var that = this;

        if(!this.sessionRef || this.sessionRef.closed)
        {
            this.sessionRef = this.userData.userSession().subscribe(session => {
                if (session != null){
                    //that.rootPage=that.userData.loggedInDestination();
                    if(!that.subscribeRef || that.subscribeRef.closed)
                    {
                        that.subscribeRef = that.userData.load().subscribe(user => {

                            that.checkLoggedInRootPage();
                            that.candidates = that.userData.get('missionCandidates');
                            that.contracts = that.userData.get('missionContracts');
                            that.notifications = that.userData.get('notifications');
                            that.badge.set(that.notifications.unread);


                        });
                    }

                    //this.rootPage = MissionsListPage;
                    that.enableMenu(true);
                    that.platformReady();
                }
                else {
                    this.rootPage=LoginPage;
                    //console.log("EVALUATE LOGIN : NOT LOGGED");
                    that.enableMenu(false);
                    that.checkLoggedOutRootPage();
                    that.platformReady();
                }
            });
        }
    }

    openPage(page: PageInterface) {
        let params = {};
        if(page.params)params=page.params;


        // the nav component was found using @ViewChild(Nav)
        // setRoot on the nav to remove previous pages and only have this page
        // we wouldn't want the back button to show in this scenario
        if (page.index) {
            params = { tabIndex: page.index };
        }

        // If we are already on tabs just change the selected tab
        // don't setRoot again, this maintains the history stack of the
        // tabs even if changing them from the menu
        //console.log(page.index, page.name);
        if (
            this.nav.getActiveChildNavs().length>0 && page.index
            && this.nav.getActive() && this.nav.getActive().name == page.name
            && page.index != 0

        ) {
            console.log("test");
            this.nav.getActiveChildNavs()[0].select(page.index);
        } else {
            // Set the root of the nav with params if it's a tab index
            //console.log(page);
            if(page.push)
            {
                console.log("Push");
                this.nav.push(page.name, params).catch((err: any) => {
                    console.log(`Didn't push nav page: ${err}`);
                });
            }
            else if(page.root)
            {
                console.log("Root nav");
                this.app.getRootNav().setRoot(page.name, params);
                this.app.getRootNav().popToRoot();
            }
            else {
                console.log("setRoot");
                var that = this;
                this.nav.setRoot(page.name, params).then(() =>{
                    //console.log(page.name);
                    if(page.index == 0 && "MissionsTabsPage" == page.name)
                        that.nav.getActiveChildNavs()[0].select(page.index);
                }).catch((err: any) => {
                    console.log(`Didn't set nav root: ${err}`);
                });
            }
        }
        if (page.logsOut === true) {

            // Give the menu time to close before changing to logged out
            this.userData.logout();
            this.nav.setRoot(LoginPage);
        }

    }
    openTutorial() {
        this.nav.setRoot(TutorialPage);
    }
    listenToLoginEvents() {
        if(!this.listeners)
        {
            this.listeners = true;
            this.events.subscribe('app:checkroot', () => {
                var that = this;
            });
            this.events.subscribe('user:identified', () => {
                var that = this;
                //console.log("EVALUATE LOGIN trigger");
                if(this.sessionRef && !this.sessionRef.closed)this.sessionRef.unsubscribe();
                if(this.subscribeRef && !this.subscribeRef.closed)this.subscribeRef.unsubscribe();
                that.evaluateLogin(true);
            });
            this.events.subscribe('user:logout', () => {
                if(this.sessionRef)this.sessionRef.unsubscribe()
                if(this.subscribeRef)this.subscribeRef.unsubscribe();
                this.enableMenu(false);
            });
        }

    }
    checkLoggedInRootPage()
    {
        var that = this;
        if(!that.nav.getActive() || (that.nav.getActive() && that.userData.anonymousPages.indexOf(that.nav.getActive().component.pageName)>=0))
        {
            that.nav.setRoot(that.userData.loggedInDestination());
        }
    }
    checkLoggedOutRootPage()
    {
        var that = this;

        if(!that.nav.getActive() || (that.nav.getActive() && that.userData.anonymousPages.indexOf(that.nav.getActive().component.pageName)<0))
        {
            that.storage.get('hasSeenTutorial')
                .then((hasSeenTutorial) => {
                    if (hasSeenTutorial) {
                        that.nav.setRoot(LoginPage);
                    } else {

                        that.nav.setRoot(TutorialPage);
                    }
                });
        }
    }
    enableMenu(loggedIn: boolean) {
        this.menu.enable(loggedIn, 'loggedInMenu');
        this.menu.enable(!loggedIn, 'loggedOutMenu');
    }
    platformReady() {
        // Call any initial plugins when ready
        this.platform.ready().then(() => {
            this.toastLog("platform ready");
            if(this.platform.is('cordova'))
            {
                this.toastLog("cordova");
                try {
                    this.splashScreen.hide();
                    // load the conference data
                    //confData.load();
                    //console.log('BAR ERROR SETTING');
                    //console.log('BAR');

                    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
                    // let status bar overlay webview
                    this.statusBar.overlaysWebView(false);
                    if(!this.platform.is('ios'))
                    {
                        this.statusBar.backgroundColorByHexString('#0081b0');
                    }
                    else
                    {
                        this.statusBar.backgroundColorByHexString('#FFFFFF');
                        this.statusBar.styleDefault();
                    }
                    this.toastLog("detect");

                    this.fcm.subscribeToTopic('all');

                    if(this.platform.is('ios'))
                        this.fcm.subscribeToTopic('ios');
                    else
                        this.fcm.subscribeToTopic('android');
                    var that = this;
                    this.fcm.getToken().then(token => {
                        that.toastLog(token);
                        if (token) {
                            window.setTimeout(function(){
                                that.userData.setFcmToken(token);
                            },3000);
                        }

                    }).catch((err: any) => {
                        that.toastLog(`error: ${err}`);
                    });;

                }
                catch(e)
                {
                    this.logger.log('Error on configure cordova',e);
                }
            }
            var that = this;
            this.userData.load().subscribe(user => {
                var availability = this.userData.get('availability');
                if(availability.available)
                {
                    that.available=availability.available;
                }
                else
                {
                    that.available=false;
                }
            });

        });
    }
    isHidden(page: PageInterface) {
        if(page.hidden) return page.hidden;
        return false;
    }
    isActive(page: PageInterface) {
        let childNav = this.nav.getActiveChildNavs()[0];

        // Tabs are a special case because they have their own navigation
        if (childNav) {
            if (childNav.getSelected() && childNav.getSelected().root === page.tabComponent) {
                return 'primary';
            }
            return;
        }

        if (this.nav.getActive() && this.nav.getActive().name === page.name) {
            return 'primary';
        }
        return;
    }
    toastLog(message: string)
    {
       /* let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 2000,
            position: 'bottom',
            closeButtonText:'Ok'
        });
        toast.present();*/
    }
    changeAvailability() {
        var availability = this.userData.get('availability');
        if(availability && availability.available)
        {
            this.userData.update('availability','available',false);
            this.nav.push('AvailabilityPage',{'available':false,'step':1});
            this.menuCtrl.close();
        }
        else
        {
            this.userData.update('availability','available',true);
            if(!this.userData.get('searchFilters') || !this.userData.get('searchFilters').job || !this.userData.get('searchFilters').job.jobs || this.userData.get('searchFilters').job.jobs.length==0)
            {
                this.nav.push('AvailabilityPage',{'available':true,'step':2});
                this.menuCtrl.close();
            }

        }
        //this.nav.push('AvailabilityPage');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts